import React from "react";

// Image-based logo. Two color variants:
// - "ink"   → full-color logo (Cap navy/Distrib violet + arrow) used on light backgrounds
// - "white" → all-white logo used on dark backgrounds
export default function Logo({ variant = "ink", className = "" }) {
    const src = variant === "white" ? "/logo-white.png" : "/logo-color.png";
    return (
        <img
            src={src}
            alt="CapDistrib"
            data-testid="cap-logo"
            className={`h-8 sm:h-9 w-auto select-none ${className}`}
            draggable={false}
        />
    );
}
